<template>
	<form class="login-form" action="javascript:void(0)" method="post" v-show="setPsw==1">
		<div class="login-logo"></div>
		<div class="login-title">内容管理系统</div>
		<input class="username" type="text" name="username" v-model="username" value="" placeholder="输入账号" />
		<div class="tipCommon"></div>
		<input class="password" type="password" name="password" v-model="password" value="" placeholder="输入密码" />
		<div class="tipCommon"></div>
		<!--<div class = "submit-btn" style  = "background: gray;color: #fff;" v-if = "disabled">登陆</div>-->
		<input type="submit" class="submit-btn" name="login-submit" id="loginSubmit" value="登录" @click="loginfun" />
	</form>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				username: "",
				password: "",
			}
		},
		props: ["setPsw"],
		methods: {
			loginfun: function() {
				if(!this.username) {
					this.common.newTip($(".username"), "请输入账号")
					return;
				}
				if(!this.password) {
					this.common.newTip($(".password"), "请输入密码")
					return;
				}
				let data = {};
				data.username = this.username;
				data.password = this.password;
				let _this = this;
				this.common.get("user/loginValidatorUsername", function(ret) {//验证用户唯一性
					_this.layer.closeAll('loading');
					if(ret.errcode == 1006) {
						_this.common.newTip($(".username"), "该用户名不存在！")
						return;
					} else if(ret.errcode == 0) {} else {
						_this.common.newTip($(".username"), "服务器忙，请稍等！")
						return;
					}
				},{username:this.username}, false, function() {
					let index = _this.layer.load(1, {
						shade: [0.1, '#fff'] //0.1透明度的白色背景
					});
				})
				this.common.post("user/login", function(ret) {//登陆
					_this.layer.closeAll('loading');
					if(ret.errcode == 1001) {
						_this.common.newTip($(".password"), "密码错误")
						return;
					}
					if(ret.errcode == 1008) {
						_this.common.newTip($(".password"), "该用户已被禁用！")
						return;
					}
					if(ret.errcode == 1007) {
						_this.$emit('setstatus', "321321");
						_this.Hub.$emit('eventBus', ret.id);
					} else if(ret.id != "") {
						localStorage.setItem('user', JSON.stringify(ret))
						location.href = "/"
					}
				},data, false, function() {
					let index = _this.layer.load(1, {
						shade: [0.1, '#fff'] //0.1透明度的白色背景
					});
				})
			}
		}

	}
</script>

<style scoped="">
	@import url("../../../static/css/login.css");
</style>


// WEBPACK FOOTER //
// src/components/loginPage/login.vue